import React from "react";
import { motion, AnimatePresence } from "framer-motion";

const menuVariants = {
  hidden: {
    clipPath: "circle(0% at 100% 0%)",
    transition: { type: "spring", stiffness: 20, damping: 5 },
  },
  visible: {
    clipPath: "circle(150% at 50% 50%)",
    transition: { type: "spring", stiffness: 20, damping: 5 },
  },
};

const Menu = ({ isOpen, onClose }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="fixed inset-0 bg-black text-white z-[10000] flex flex-col items-center justify-center text-3xl"
          variants={menuVariants}
          initial="hidden"
          animate="visible"
          exit="hidden"
        >
          <div
            className="absolute inset-0 bg-cover bg-center opacity-10"
            style={{ backgroundImage: `url('https://albidayahgroups.com/Media/Restaurant/pattern%20bg.svg')` }}
          ></div>
          <button onClick={onClose} className="absolute top-8 right-20 max-sm:right-5 text-2xl">
            ✕
          </button>
          <a href="/" className="my-4 hover:text-gray-300 relative">Home</a>
          <a href="/branches" className="my-4 hover:text-gray-300 relative">Branches</a>
          <a href="/gallery" className="my-4 hover:text-gray-300 relative">Gallery</a>
          <a href="/about-us" className="my-4 hover:text-gray-300 relative">About Us</a>
          <a href="/contact" className="my-4 hover:text-gray-300 relative">Contact Us</a>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Menu;
